import {
    RuleActionType,
    TransactionRuleAction,
    TransferRuleDirection,
} from "../../types/transactionRule";

export class TransactionRuleActionDto {
    id: string;
    actionType: RuleActionType;
    value: TransactionRuleAction["value"];
    transferDirection: TransferRuleDirection | null;

    constructor(action: TransactionRuleAction) {
        this.id = action.id;
        this.actionType = action.actionType;
        this.value = action.value;
        this.transferDirection = action.transferDirection;
    }

    static deserialize(dto: TransactionRuleActionDto): TransactionRuleAction {
        return {
            id: dto.id,
            actionType: dto.actionType,
            value: dto.value,
            transferDirection: dto.transferDirection,
        };
    }
}
